export const MAP_CREATE_MODE_PREFIX = 'create';

export const MAPBOX_CTRL_PREFIX = 'mapboxgl-ctrl';
